import type { IconPrimitives, IconProps } from './types';

export const buildSupportIcon = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  SupportIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M23.5 16.5H5.5L0.5 21.5V0.5H23.5V16.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' />
      <Path d='M11.9991 3.00024L10.4994 4.5L11.9991 5.99976L13.4989 4.5L11.9991 3.00024Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' />
      <Path d='M13.5 12.5V7.5H10L10.5 9.5H11.5V12.5H10.5V14.5H14.5V12.5H13.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' />
    </Svg>
  ),
});
